import React from "react";

const IMG =
  "https://images.pexels.com/photos/1029622/pexels-photo-1029622.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function AuthShell({ children, title, subtitle }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#fdfdfd]">
      {/* Left: image / brand */}
      <div className="hidden lg:flex relative bg-zinc-100 overflow-hidden border-r border-zinc-200">
        <img
          src={IMG}
          alt="Architecture"
          className="absolute inset-0 w-full h-full object-cover grayscale opacity-80"
        />
        <div className="absolute inset-0 bg-white/20" />
        <div className="relative z-10 p-12 flex flex-col justify-between w-full">
          <div>
            <div className="flex items-baseline gap-2">
              <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-800 font-mono">
                BeDocs
              </div>
              <div className="h-1 w-1 bg-[#FF3B30]" />
            </div>
            <h2 className="mt-2 text-4xl font-semibold tracking-tight text-zinc-900">
              Gestion<br />Documentaire
            </h2>
          </div>
          <div />

        </div>
      </div>

      {/* Right: form */}
      <div className="flex items-center justify-center p-6 md:p-12">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8">
            <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500 font-mono">
              BeDocs · Gestion Documentaire
            </div>
          </div>
          <h1 className="text-3xl font-semibold tracking-tight text-zinc-900">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-zinc-600">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
